import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivityModel, EActivityContentType, EFileType, ProjectSummaryContentModel} from '../../../@models';
import {ApiService} from '../../../@core/service/api.service';
import { InternalUpdatesComponent } from '../../erp/reports/reports-printer/internal-updates/internal-updates.component';

@Component({
  selector: 'ngx-news-entry',
  templateUrl: './news-entry.component.html',
  styleUrls: ['./news-entry.component.scss'],
})

export class NewsEntryComponent implements OnInit {

  @Input() activity: ActivityModel;
  @Output() show: EventEmitter<ActivityModel> = new EventEmitter<ActivityModel>();

  @ViewChild('internalUpdates') internalUpdates: InternalUpdatesComponent;

  ContentType = EActivityContentType;

  constructor(
    private api: ApiService,
  ) { }

  ngOnInit() {

  }

  public getImageUrl() {
    if (this.activity.files != null && this.activity.files.length > 0) {
      const image = this.activity.files.find(x => Number(x.type) === EFileType.Image);
      return image != null ? image.url : null;
    }
  }

  async downloadVr() {
    return this.api.downloadVisitReport(this.activity);
  }

  async downloadInternalUpdates() {
    await this.internalUpdates.init((this.activity.content as ProjectSummaryContentModel).docCode);
    this.internalUpdates.generatePDF();
  }
}
